import {HelpIcon} from "./HelpIcon";
import React from "react";
import {usePermission} from "../../Hooks/PermissionHooks";

export function NoModeledUpliftWarning() {
	
	const permission = usePermission();
	
	return <div className="sb-no-items-warning">
		No Modeled Uplift data available.
		{
			permission('update_survey_data') &&
			<HelpIcon>
				Modeled Uplift can be designated on the Conservation Action Survey Pages (e.g. Eligibility, Design,
				As-Built).
			</HelpIcon>
		}
	</div>;
}
